import type { Service } from '@/types';

export function getServicePriceForCurrency(
  service: Service,
  currency: string
): number | null {
  if (service.prices?.length) {
    const exact = service.prices.find((p) => p.currency === currency);
    if (exact) return exact.price;
    const primary = service.prices.find((p) => p.is_primary);
    if (primary) return primary.price;
    return service.prices[0]?.price ?? null;
  }
  return service.price;
}

export function formatCurrencyAmount(amount: number, currency: string): string {
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
    }).format(amount);
  } catch {
    return `${currency} ${amount.toFixed(2)}`;
  }
}
